export const parseNarrativeStrategyBlock = (markdown = "") => {
  const raw = String(markdown || "").trim();
  if (!raw) return null;

  const headingMatch = raw.match(/^\s*\*\*([^*]+?Strategy)\*\*\s*/i);
  if (!headingMatch) return null;

  const title = String(headingMatch[1] || "").trim();
  const body = raw.slice(headingMatch[0].length).trim();
  if (!body) return null;

  return { title, body };
};

export const isNarrativeStrategyBlock = (markdown = "") =>
  Boolean(parseNarrativeStrategyBlock(markdown));

export const normalizeNarrativeStrategyTitle = (title = "") =>
  String(title || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const splitNarrativeStrategySentences = (text = "") => {
  const raw = String(text || "").trim();
  if (!raw) return [];
  const matches = raw.match(/.+?(?:[.!?]+(?=\s|$)|$)/g);
  return (matches || []).map((s) => s.trim()).filter(Boolean);
};
